
import { merchandise } from '../../../mocks/merchandise';

const MerchandiseSection = () => {
  return (
    <section id="merchandise" className="py-32 bg-primary-dark relative overflow-hidden">
      {/* Enhanced background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 20% 50%, rgba(0, 212, 255, 0.12) 0%, transparent 50%),
                           radial-gradient(circle at 80% 50%, rgba(0, 102, 255, 0.12) 0%, transparent 50%)`
        }}></div>
        
        {/* Glow orbs */}
        <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-primary-blue/12 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/3 left-1/4 w-64 h-64 bg-primary-deepblue/15 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        
        {/* Horizontal lines */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-blue/40 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-primary-blue"></div>
            <span className="text-primary-blue font-inter text-sm font-semibold tracking-widest uppercase" style={{ textShadow: '0 0 20px rgba(0, 212, 255, 0.8)' }}>
              Shop
            </span>
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-primary-blue"></div>
          </div>
          <h2 className="text-5xl md:text-6xl font-orbitron font-bold text-white mb-4" style={{ textShadow: '0 0 40px rgba(0, 212, 255, 0.7)' }}>
            MARCHE MERCHANDISE
          </h2>
          <p className="text-gray-400 font-inter text-lg">Premium apparel and professional detailing products</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {merchandise.map((item, index) => (
            <div
              key={item.id}
              className="group relative bg-gradient-to-b from-primary-black/90 to-primary-dark/90 backdrop-blur-sm rounded-3xl overflow-hidden border-2 border-primary-blue/30 transition-all duration-500 hover:-translate-y-3 hover:border-primary-blue cursor-pointer"
              style={{ 
                boxShadow: '0 0 25px rgba(0, 212, 255, 0.2), inset 0 0 20px rgba(0, 212, 255, 0.03)',
                animationDelay: `${index * 0.1}s`
              }}
            >
              {/* Hover glow effect */}
              <div className="absolute -inset-0.5 bg-gradient-to-b from-primary-blue/30 to-primary-deepblue/30 rounded-3xl opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-500"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-primary-blue/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                {/* Blue overlay on hover */}
                <div className="absolute inset-0 bg-primary-blue/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>

              <div className="relative p-6 text-center space-y-3">
                <p className="text-primary-blue font-inter text-xs font-semibold tracking-wider uppercase" style={{ textShadow: '0 0 15px rgba(0, 212, 255, 0.6)' }}>
                  {item.category}
                </p>
                <h3 className="text-lg font-inter font-bold text-white group-hover:text-primary-blue transition-colors duration-300">
                  {item.name}
                </h3>
                <p className="text-2xl font-inter font-bold text-primary-blue" style={{ textShadow: '0 0 20px rgba(0, 212, 255, 0.7)' }}>
                  ${item.price}
                </p>
                <button 
                  className="group/btn relative w-full py-3 bg-gradient-to-r from-primary-blue to-primary-deepblue text-white font-inter font-semibold text-sm rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer overflow-hidden" 
                  style={{ boxShadow: '0 0 25px rgba(0, 212, 255, 0.5)' }}
                >
                  <span className="relative z-10">ADD TO CART</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MerchandiseSection;
